import React from 'react';

const ReferChecksCard = ({
    isEditReferChecks,
    setIsEditReferChecks,
    updateCandidateReferChecks,
    onAddReferContents,
    referChecks,
    onChangeReferContentInput,
    onProcessReferCheck,
    onDeleteReferContents,
    mode = 'Edit', // Default to Edit mode for backward compatibility
}) => {
    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>People to Check Reference</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEditReferChecks &&
                            <>
                                <button type='button'
                                        className='btn btn-default mr-3'
                                        onClick={() => {
                                            setIsEditReferChecks(false);
                                        }}
                                >
                                    Cancel
                                </button>
                                <button type='button'
                                        className='btn btn-info mr-3'
                                        onClick={() => {
                                            updateCandidateReferChecks();
                                        }}
                                >
                                    Save
                                </button>
                                <button className='btn btn-primary' type={'button'}
                                        onClick={(event) => onAddReferContents(event)}>
                                    <i className='fas fa-plus'/> Thêm
                                </button>
                            </>
                        }
                        {!isEditReferChecks &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEditReferChecks(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
                {mode === 'Search' && (
                    <div className='card-tools'>
                        <button className='btn btn-primary' type={'button'}
                                onClick={(event) => onAddReferContents(event)}>
                            <i className='fas fa-plus'/> Thêm
                        </button>
                    </div>
                )}
            </div>
            <div className='card-body table-responsive w-100'>
                <table
                    className='table table-hover table-bordered text-nowrap my-3'
                >
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Nội dung</th>
                        <th style={{width: '50px'}}>Hành động</th>
                    </tr>
                    </thead>
                    <tbody>
                    {referChecks && referChecks.length > 0 && referChecks.map((item, index) => (
                        <tr key={`refer_content_${index}`}>
                            <td>{index + 1}</td>
                            <td>
                                <textarea className='form-control'
                                          value={item.content}
                                          disabled={!isEditReferChecks}
                                          name={`item_refer_check_${index}`}
                                          onChange={event => onChangeReferContentInput(event, index)}/>
                            </td>
                            <td>
                                <button className='btn btn-primary btn-sm mr-3'
                                        type={'button'}
                                        disabled={!isEditReferChecks || item.processed}
                                        onClick={() => onProcessReferCheck(index)}>
                                    Process
                                </button>
                                <button className='btn btn-danger btn-sm'
                                        type={'button'}
                                        disabled={!isEditReferChecks}
                                        onClick={() => onDeleteReferContents(index)}>
                                    Xóa
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

            </div>
        </div>
    );
};

export default ReferChecksCard;


